import Vue from "vue";
import { FileManagerPlugin, DetailsView, NavigationPane, Toolbar } from "@syncfusion/ej2-vue-filemanager";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
Vue.use(FileManagerPlugin);
export default {
  name: "staffDocument",
  props: [
    "isDocumenViewMode"
  ],
  mounted() {
    this.getBaseUrl();
  },
  provide() {
    return {
      filemanager: [DetailsView, NavigationPane, Toolbar]
    };
  },
  data: () => ({
    ajaxSettings:
    {
      url: "",
      getImageUrl: "",
      uploadUrl: "",
      downloadUrl: ""
    },
    isDocumentLoad: false,
    richtextHeight: 0
  }),
  computed: {
  },
  methods: {
    getBaseUrl() {
      var self = this;
      const serverRouter = store.getters[StoreGetter.serverRouter];
      if (serverRouter) {
        self.ajaxSettings.url = serverRouter.ServerIP + "DocLib/SQLFileOperations/" + serverRouter.CompCode;
        self.ajaxSettings.getImageUrl = serverRouter.ServerIP + "DocLib/SQLGetImage/" + serverRouter.CompCode;
        self.ajaxSettings.uploadUrl = serverRouter.ServerIP + "DocLib/SQLUpload/" + serverRouter.CompCode;
        self.ajaxSettings.downloadUrl = serverRouter.ServerIP + "DocLib/SQLDownload/" + serverRouter.CompCode;
        self.init();
        self.isDocumentLoad = true;
      }
    },
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var employeeData = $(".employee-data .content-header").height();
      var employeeHeader = $(".employee-header").height();
      var employeeProfileHeader = $(".employee-profile-header").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var employeeDataHeight = employeeData != undefined ? employeeData : 36;
      var employeeHeaderHeight = employeeHeader != undefined && employeeHeader != 0 ? employeeHeader : 218;
      var employeeProfileHeaderHeight = employeeProfileHeader != undefined && employeeProfileHeader != 0 ? employeeProfileHeader : 33;
      self.richtextHeight = docHeight - headHeight - employeeDataHeight - employeeHeaderHeight - employeeProfileHeaderHeight - 50;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeDocument.js